import { useState, useEffect } from 'react';
import { API_BASE } from '../config/api';

/**
 * Custom hook to fetch taxonomy data from Master Taxonomy API
 * @param {string|null} type - Optional taxonomy type to filter (e.g., 'field_of_study')
 * @returns {object} - { data, loading, error, getTaxonomyByType }
 */
export const useTaxonomy = (type = null) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const backendUrl = API_BASE;

  useEffect(() => {
    const fetchTaxonomy = async () => {
      try {
        setLoading(true);
        const url = type 
          ? `${backendUrl}/api/public/master-taxonomy?type=${type}`
          : `${backendUrl}/api/public/master-taxonomy`;
        
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error('Failed to fetch taxonomy data');
        }
        
        const result = await response.json();
        setData(result.items || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTaxonomy();
  }, [type, backendUrl]);

  /**
   * Get taxonomy items by specific type from already loaded data
   * Useful when fetching all taxonomy at once
   */
  const getTaxonomyByType = (taxonomyType) => {
    return data.filter(item => item.type === taxonomyType);
  };

  return { data, loading, error, getTaxonomyByType };
};

export default useTaxonomy;
